module.exports = __webpack_public_path__ + "static/event_logo-86d618da784fc93441f64129dc566e69.png";